var render = function render(){var _vm=this,_c=_vm._self._c;return _c('NcSelectTags',{attrs:{"value":_vm.integerValue,"multiple":false},on:{"input":_vm.emitInput}})
}
var staticRenderFns = []

export { render, staticRenderFns }